module.exports = __webpack_public_path__ + "img/give-get_1x.1884477.png";


//////////////////
// WEBPACK FOOTER
// ./scripts/src/assets/raf/give-get_1x.png
// module id = 688
// module chunks = 0